import styled from 'styled-components';
import { Row } from 'react-bootstrap';

const Divider = styled.div`
  border-bottom: 1px solid #98D6FF;
  margin-top: 40px;
  margin-bottom: 30px;
`;

const Heading = styled.h2`
  color: #F8444F;
  text-align: center;
  font-size: 32px;
  padding-top: 40px;
  font-family: 'Poppins', 'Roboto Slab', serif;
  font-weight: 600;
`;

const FormBox = styled.div`
  //background-color: #efefef;
  color: #21174F;
  padding: 20px;
  width: 90%;
  margin: auto auto 20px;
  border-radius: 10px;
  font-size: 14px;
`;

const Box = styled.div`
  min-height: 8em;
  width: 80%;
  align-items: center;
  background-color: white;
  border-radius: 10px;
  margin-top: 5vh;
`;

const QuestionRow = styled(Row)`
  line-height: 60px;
`;
const QuestionLabel = styled.div`
  line-height: 24px;
`;
const Footer = styled.p`
  padding-top: 10px;
  font-size: 0.9em;
`;

const BrochureSection = styled.div`
  width: 100%;
  position: relative;
  padding-bottom: 80px;
  background-color: #f8f6f2;
`;

const Content = styled.div`
  width: 100%;
  min-height: 600px;
  display: flex;
  justify-content: center;
`;

const ValidationError = styled.div`
  padding-left: ${(props) => (props.showError ? '20px' : '0')};
  padding-top: ${(props) => (props.showError ? '20px' : '0')};
  padding-right: ${(props) => (props.showError ? '20px' : '0')};
  background-color: ${(props) => (props.showError ? 'pink' : 'transparent')};
  margin-bottom: ${(props) => (props.showError ? '2px' : '0')};
  border-radius: 10px;
`;

const BrokerApplicationNavigation = styled.div`
  min-height: 31px;
  margin-top: 30px;
  margin-bottom: 30px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  overflow: auto;
  font-family: 'Poppins', 'Roboto Slab', serif;
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  padding-right: 20px;
  padding-left: 20px;
`;

const NavigationButton = styled.button`
  height: 60px;
  min-width: 120px;
  cursor: pointer;
  font-size: 16px;
  -webkit-transition: 0.3s ease;
  transition: 0.3s ease;
  align-items: center;
  justify-content: space-around;
  padding: 1em 2em;
  position: relative;
  border-radius: 100px;
  font-family: 'Poppins', 'Roboto', sans-serif;
  background-color: ${(props) => (props.type === 'button' ? 'grey' : '#F8444F')};
  border: 1px solid ${(props) => (props.type === 'button' ? 'grey' : '#F8444F')};
  color: #ffffff;
  box-shadow: 0 0.125em 0.175em rgba(0, 0, 0, 0.3);
  display: flex;
  font-weight: bold;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const ErrorMessage = styled.span`
  color: #F8444F;
  font-size: smaller;
  font-family: 'Poppins', 'Roboto', sans-serif;
`;

export {
  Divider,
  Heading,
  FormBox,
  Box,
  QuestionRow,
  QuestionLabel,
  Footer,
  BrochureSection,
  Content,
  ValidationError,
  BrokerApplicationNavigation,
  NavigationButton,
  ErrorMessage,
};
